var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "sidebar-kv" },
    _vm._l(_vm.visibleRows, function (row, i) {
      return _c(
        "div",
        { key: i, staticClass: "sidebar-kv-row", class: { right: row.right } },
        [
          _c("div", { staticClass: "sidebar-kv-label" }, [
            _vm._v(_vm._s(row.label)),
          ]),
          _c(
            "div",
            {
              staticClass: "sidebar-kv-value",
              class: { empty: _vm.isEmpty(row), warning: row.warning },
            },
            [
              _vm.isEmpty(row)
                ? [_vm._v(_vm._s(_vm.$ct("sidebar.not-filled")))]
                : row.href
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: row.href,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [_vm._v(_vm._s(row.value))]
                  )
                : row.badge
                ? _c(
                    "span",
                    { staticClass: "sidebar-kv-badge", class: row.badge },
                    [_vm._v(_vm._s(row.value))]
                  )
                : [_vm._v(_vm._s(row.value))],
            ],
            2
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }